import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
interface HeaderProps {
  setPage: (page: string) => void;
  currentPage: string;
}
export function Header({
  setPage,
  currentPage
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    id: 'home'
  }, {
    name: 'Services',
    id: 'services-hub'
  }, {
    name: 'Industries',
    id: 'industries'
  }, {
    name: 'About',
    id: 'about'
  }, {
    name: 'Contact',
    id: 'contact'
  }];
  const handleNavClick = (id: string) => {
    setPage(id);
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };
  return <header className={`sticky top-0 z-40 w-full transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4 border-b border-steel-100'}`} data-id="element-77">
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center" data-id="element-78">
        {/* Logo */}
        <button onClick={() => handleNavClick('home')} className="focus:outline-none group" aria-label="Merem Blasting Home" data-id="element-79">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.meremblasting.com/uploaded/images/Misc%20icons%20and%20images/logo.png" alt="Merem Blasting" className="h-12 md:h-16 w-auto transition-opacity group-hover:opacity-80" data-id="element-80" />
        </button>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-81">
          <ul className="flex space-x-6" data-id="element-82">
            {navLinks.map(link => <li key={link.id} data-id="element-83">
                <button onClick={() => handleNavClick(link.id)} className={`font-heading uppercase font-semibold tracking-wider text-base transition-colors hover:text-brand-red ${currentPage === link.id ? 'text-brand-red' : 'text-charcoal'}`} data-id="element-84">
                  {link.name}
                </button>
              </li>)}
          </ul>
          <Button variant="primary" size="sm" onClick={() => handleNavClick('contact')} data-id="element-85">
            Get a Quote
          </Button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden p-2 text-charcoal hover:text-brand-red focus:outline-none" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-86">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-87" /> : <MenuIcon className="w-6 h-6" data-id="element-88" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      <div className={`lg:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-steel-100 transition-all duration-300 origin-top ${mobileMenuOpen ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0 pointer-events-none'}`} data-id="element-89">
        <nav className="flex flex-col px-4 py-6 space-y-4" data-id="element-90">
          {navLinks.map(link => <button key={link.id} onClick={() => handleNavClick(link.id)} className={`text-left font-heading uppercase font-bold tracking-wider text-xl py-2 border-b border-steel-100 ${currentPage === link.id ? 'text-brand-red' : 'text-charcoal'}`} data-id="element-91">
              {link.name}
            </button>)}
          <div className="pt-4" data-id="element-92">
            <Button variant="primary" className="w-full" onClick={() => handleNavClick('contact')} data-id="element-93">
              Get a Quote
            </Button>
          </div>
        </nav>
      </div>
    </header>;
}